import { render } from "./authLayout.vue?vue&type=template&id=1d0fbc2f&scoped=true&ts=true&lang=pug"
import script from "./authLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./authLayout.vue?vue&type=script&lang=ts&setup=true"

import "./authLayout.vue?vue&type=style&index=0&id=1d0fbc2f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0fbc2f"]])

export default __exports__